<template>
  <div class="main">
    <img :src="channelInfo.image" alt="">
    <div class="ban_information">
      <div class="ban_title">{{channelInfo.name}}</div>
      <div class="ban_con">{{channelInfo.summary}}</div>
    </div>
  </div>
</template>

<script>
import { queryChannelInfoByID } from '@/api/channel/channel.js'
export default {
  data() {
    return {
      channelInfo: {},//栏目详情
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let id = window.location.href.substr(window.location.href.lastIndexOf('/') + 1, 2);  
      // console.log(id);
      let result = await queryChannelInfoByID(id);
      // console.log('------------------');
      // console.log(result);
      this.channelInfo = result.data;
    }
  },
}
</script>

<style lang="scss" scoped="scoped">
.main {
  position: relative;
  height: 349px;
  img {
    width: 100%;
    height: 100%;
  }
  .ban_information {
    position: absolute;
    top: 35%;
    left: 15%;
    .ban_title {
      margin-bottom: 10px;
      font-size: 40px;
      font-weight: 700;
      color: #3B3B3B;
    }
    .ban_con {
      font-size: 16px;
      color: rgb(38, 38, 38);
    }
  }
}
</style>